import styled, { css } from 'styled-components';
import { space } from 'styled-system';
import { rgba } from 'utils/polished';

import IconStyles from '../base/iconStyles';
import TypographyStyles from '../base/typographyStyles';
import TextfieldStyles from '../base/textfieldStyles';

const ToolbarStyles = styled.div`
  ${space}

  max-width: 18rem;
  margin-left: auto;
  margin-right: auto;
`;

const ToolbarContentStyles = styled.div`
  display: none;
  padding: 0.75rem;
`;

const ToolbarColumnStyles = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${TextfieldStyles} {
    width: 4rem;
  }
`;

const ToolbarHeaderStyles = styled.div`
  cursor: pointer;
  display: flex;
  padding: ${props => props.theme.space[2]};
  position: relative;
  padding-left: 3.5rem;

  &:hover {
    background: ${props => rgba(props.theme.colors.primary, 0.08)};

    ${IconStyles}:last-child {
      color: ${props => props.theme.colors.primary};
    }
  }

  ${IconStyles} {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    &:first-child {
      left: ${props => props.theme.space[2]};
    }

    &:last-child {
      transition: 0.2s linear all;
      right: ${props => props.theme.space[2]};
      transform-origin: center;
      transform: rotate(-90deg);
      margin-top: -4px;
    }
  }

  ${TypographyStyles.HeadingStyles} {
    text-transform: none;
  }
`;

const ToolbarSectionStyles = styled.div`
  border: 0.0625rem solid ${props => rgba(props.theme.colors.primary, 0.1)};

  ${props =>
    props.isOpened &&
    css`
      ${ToolbarHeaderStyles} {
        background: ${rgba(props.theme.colors.primary, 0.08)};

        ${IconStyles}:last-child {
          color: ${props.theme.colors.primary};
          transform: rotate(90deg);
        }
      }

      ${ToolbarContentStyles} {
        display: block;
      }
    `};

  & + & {
    margin-top: ${props => props.theme.space[1]};
  }
`;

ToolbarStyles.SectionStyles = ToolbarSectionStyles;
ToolbarStyles.HeaderStyles = ToolbarHeaderStyles;
ToolbarStyles.ColumnStyles = ToolbarColumnStyles;
ToolbarStyles.ContentStyles = ToolbarContentStyles;

export default ToolbarStyles;
